module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue5.96c331042568d4fc8f21ecbc425e7069.png";